<div class="p-3">
  <ng-container *ngIf="!matchedComponentPromise">
    There is no dedicated UI Display component for <strong>{{ path }}</strong>
  </ng-container>
  <ng-template #componentTarget></ng-template>
</div>
